// alt значка: у ботов — прежний «Бот», у ИИ-игрока промо-матча — свой
export const BOT_MARK_ALT = 'Бот';
export const AI_MARK_ALT = 'ИИ';

/**
 * Текст alt у значка рядом с игроком (см. checkIfBotMarkShown): ИИ-игрок
 * промо-матча — «ИИ», любой бот — «Бот». Пока картинки метки ИИ нет в public,
 * браузер показывает именно alt, и ИИ не должен читаться ботом.
 *
 * @param {Object} [player]
 * @returns {string}
 */
export const getBotMarkAlt = (player) => (player && player.isAi ? AI_MARK_ALT : BOT_MARK_ALT);
